<article [id]="extension() !== 'shuffle' ? 'calendar-entry-modal' : null"
	[class]="'calendar-entry__modal ' + 'calendar-entry__modal--' + calendarEntry?.status"
	[class.calendar-entry__modal--standalone]="isStandalone()"
	[class.calendar-entry__modal--non-standalone]="!isStandalone()"
	(click)="$event.stopPropagation()"
  	#calendarModal>

	<div
		[class]="'calendar-entry__modal-header-container calendar-entry__modal-header-container--' + (calendarEntry?.status || 'default')">
		<div class="calendar-entry__icon material-symbols-rounded">
			<div
				[class]="'calendar-entry__icon-container calendar-entry__icon-container--' + (calendarEntry?.status || 'default')">
				<h2 [title]="calendarEntry?.icon ?? moodIcons[calendarEntry?.status ?? 'average']">
					{{
					calendarEntry?.icon ?? ((calendarEntry?.status) !== undefined ? moodIcons[calendarEntry?.status ?? 'average']
					: '')
					}}
				</h2>
			</div>
		</div>
		<header class="calendar-entry__modal-header">
			@if (!calendarEntry?.title) {
				<h1 [class]="'calendar-entry__day-date ' + 'calendar-entry__day-date--' + calendarEntry?.status">
					{{ calendarMonths[month()].shortName }} {{ day() + 1 }}, {{ year() }}
				</h1>
			} @else {
				<h3 [class]="'calendar-entry__day-date ' + 'calendar-entry__day-date--' + calendarEntry?.status">
					{{ calendarMonths[month()].shortName }} {{ day() + 1 }}, {{ year() }}
				</h3>
			}
			<h2 class="calendar-entry__date-name">{{ activeDayName }}</h2>
			@if (isStandalone() && extension() === undefined) {
				<button [class]="'calendar-entry__modal-close '  + 'calendar-entry__modal-close--' + calendarEntry?.status" title="Close" (click)="closeButton()">
					<h2 class="calendar-entry__modal-close-text material-symbols-rounded">close</h2>
				</button>
			} @else if (isStandalone() && extension() === "shuffle") {
				<button [class]="'calendar-entry__modal-shuffle '  + 'calendar-entry__modal-shuffle--' + calendarEntry?.status" title="Shuffle" (click)="shuffleButton()">
					<h2 class="calendar-entry__modal-shuffle-text material-symbols-rounded">repeat</h2>
				</button>
			}
		</header>

		@if (calendarEntry?.spotify) {
			<div class="calendar-entry__spotify-image-container--header" [attr.id]="'calendar-entry-spotify'">
				@let art = spotifyImage();
				<img [src]="art ?? ''" class="calendar-entry__spotify-image--header"
					[class.calendar-entry__spotify-image--header-invisible]="!art"
					[alt]="'Album cover of ' + (calendarEntry?.spotify?.album)" loading="lazy" decoding="async" width="300px"
					height="300px" fetchpriority="low" />
				<!-- <span
					class="calendar-entry__spotify-image calendar-entry__spotify-image--placeholder material-symbols-rounded">album</span> -->
			</div>
		}
	</div>

	<section [class]="'calendar-entry__modal-content ' + 'calendar-entry__modal-content--' + calendarEntry?.status">

		<header [class]="'calendar-entry__modal-content-header ' + 'calendar-entry__modal-content-header--' + calendarEntry?.status">
			@if (calendarEntry?.title) {
				<h1 class="calendar-entry__modal-header-text">{{ calendarEntry?.title }}</h1>
			}
		</header>
		<section class="calendar-entry__modal-information-row" [class.calendar-entry__modal-information-row--no-header-text]="!calendarEntry?.title">
			<div class="calendar-entry__modal-information-group">
				@if (canWebShare) {
					<button class="calendar-entry__action" (click)="webShareEntry()">
						<span class="material-symbols-rounded">share</span> Share entry
					</button>
				} @else {
					<button class="calendar-entry__action" (click)="copyLinkToClipboard()">
						<span class="material-symbols-rounded">content_copy</span>{{ copyLinkText }}
					</button>
				}
				@if (isStandalone()) {
					<a class="calendar-entry__action" [routerLink]="openReaderLink" 
					role="link" 
					[attr.aria-label]="'Open the calendar reader for ' + (calendarMonths[month()]['shortName']) + ' ' + (day() + 1) + ', ' + year()"
					[attr.title]="'Open the calendar reader for ' + (calendarMonths[month()]['shortName']) + ' ' + (day() + 1) + ', ' + year()"
					>
						<span class="material-symbols-rounded" aria-hidden="true">two_pager</span> Open reader
					</a>
				}
			</div>
			<div class="calendar-entry__modal-information-group">
				@if (day() === -1 || year() === 2017) {
					<section class="calendar-entry__information-block"><span class="material-symbols-rounded" aria-hidden="true">egg</span> Easter egg</section>
				} @else {
					<app-weather [year]="year()" [month]="month() + 1" [day]="day() + 1"></app-weather>
				}
				@if (dayData().location) {
					<section class="calendar-entry__information-block">
						<span class="material-symbols-rounded" aria-hidden="true">{{ dayData().location?.icon ?? "pin_drop" }}</span> {{ dayData().location?.place }}
					</section>
				}
				<section class="calendar-entry__information-block"><span class="material-symbols-rounded" aria-hidden="true">{{ moodIcons[dayData().status] }}</span> {{ moodText[dayData().status] }}</section>
			</div>
		</section>
		<markdown ngPreserveWhitespaces class="calendar-entry__modal-reason"
			[class.calendar-entry__modal-reason--no-header]="!calendarEntry?.title"
			[data]="calendarEntry?.reason ?? 'Nothing noteworthy happened today lol'"></markdown>

		@if (calendarEntry?.spotify) {
			<ng-container [ngTemplateOutlet]="spotify"></ng-container>
		}
		@if (extension() !== "shuffle") {
			<section class="calendar-entry__actions" [class.calendar-entry__actions--bottom]="!calendarEntry?.spotify">
				<!-- <button class="calendar-entry__action" (click)="navigate('prev')">
					<span class="material-symbols-rounded">arrow_back</span>Previous entry
				</button>
				<button class="calendar-entry__action" (click)="navigate('next')">
					Next entry<span
						class="calendar-entry__action-icon calendar-entry__action-icon--forward material-symbols-rounded">arrow_forward</span>
				</button> -->
				@if (isStandalone()) {
				<button class="calendar-entry__action" (click)="navigate('prev')">
					<span class="material-symbols-rounded">arrow_back</span>Previous entry
				</button>
				<button class="calendar-entry__action" (click)="navigate('next')">
					Next entry<span
						class="calendar-entry__action-icon calendar-entry__action-icon--forward material-symbols-rounded">arrow_forward</span>
				</button>
				}
				@else {
					<a
						[routerLink]="prevLink()"
						class="calendar-entry__action"
						routerLinkActive="calendar-entry__action--active"
						(click)="scrollToTop()"
					>
						<span class="material-symbols-rounded">arrow_back</span>
						Previous entry
					</a>
					<a
						[routerLink]="nextLink()"
						class="calendar-entry__action"
						routerLinkActive="calendar-entry__action--active"
						(click)="scrollToTop()"
					>
						Next entry
						<span
							class="calendar-entry__action-icon calendar-entry__action-icon--forward material-symbols-rounded"
						>
							arrow_forward
						</span>
					</a>
				}
			</section>
		}
	</section>
</article>

<ng-template #spotify>
	<section class="calendar-entry__spotify" [class.calendar-entry__spotify--featured]="calendarEntry?.resonatedLyrics"
		[attr.id]="'spotify-image'" [title]="(calendarEntry?.spotify?.artist) + ' – ' + (calendarEntry?.spotify?.song)"
		#pixelMapSpotify>
		<a [href]="(calendarEntry?.spotify?.link)" target="_blank" class="calendar-entry__modal-spotify"
			[class.calendar-entry__modal-spotify--featured]="calendarEntry?.resonatedLyrics">
			<section class="calendar-entry__modal-info">
				<div class="calendar-entry__spotify-image-container">
					@let art = spotifyImage();
					@if (art) {
					<img [src]="art | safeResourceUrl"
						class="calendar-entry__spotify-image"
						[class.calendar-entry__spotify-image--invisible]="!art"
						[alt]="'Album cover of ' + (calendarEntry?.spotify?.album)" loading="lazy" decoding="async" fetchpriority="low" />
					}
					@if (!art) {
						<span class="calendar-entry__spotify-image calendar-entry__spotify-image--placeholder material-symbols-rounded">album</span>
					}
				</div>
				<div class="calendar-entry__spotify-text">
					<div class="calendar-entry__spotify-song">
						<span class="calendar-entry__spotify-title">{{ calendarEntry?.spotify?.song }}</span>
						<em class="calendar-entry__spotify-artist">{{ calendarEntry?.spotify?.artist }}</em>
					</div>
				</div>
			</section>

			@if (calendarEntry?.resonatedLyrics) {
			<section class="calendar-entry__modal-info calendar-entry__modal-info--lyrics">
				@for (line of calendarEntry?.resonatedLyrics; track $index) {
				<span class="calendar-entry__resonated-lyrics">{{ line }}</span>
				}
			</section>
			}

			<span class="calendar-entry__spotify-click">
				<em class="material-symbols-rounded calendar-entry__spotify-click-icon"> open_in_new </em> Listen on
				Spotify
			</span>
		</a>
	</section>
</ng-template>
